<template>
<div>

  <v-card v-if='integration && integration.id' class='mt-2'  >
    <v-card-title class='subheading' >
      <v-btn
        :loading='requests.forms.loading'
        @click='getForms' icon small ><v-icon small>replay</v-icon></v-btn>
      Jotform
      <v-spacer/>
      <v-chip label dark color="success" >BETA</v-chip>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pt-1" >
      <v-layout row >
        <v-flex xs4 class='pr-0' >
          <v-list dense two-line class='pa-0'>
            <v-subheader class='overline' >Jotforms</v-subheader>
            <v-divider ></v-divider>
            <template v-for='form in filteredForms' >

              <form-list-item
                :item="form"
                :show-deleted="showDeleted"
                :key="form.id"
                @link="showLinkFormDialog"
                @selected="setSelectedForm" />

              <v-divider v-if='showDeleted || form.status !== "DELETED"'
                :key='`div-${form.id}`' />

            </template>
          </v-list>
          <div class="ml-3" >
            <v-checkbox dense hide-messages small v-model='showDeleted' label='Show deleted forms' class="ma-0 mt-2 pa-0" />
            <v-checkbox dense hide-messages small v-model='showArchived' label='Show archived forms' class="ma-0 pa-0" />
            <v-checkbox dense hide-messages small v-model='showUnlinked' label='Show unlinked forms' class="ma-0 pa-0" />
          </div>
        </v-flex>
        <v-divider vertical></v-divider>
        <v-flex xs8 >
          <v-card v-if='selectedForm && selectedForm.id' flat>
            <v-toolbar dense flat class="ma-0" >
              {{selectedForm.title}}
              <v-spacer></v-spacer>

              <v-btn flat small
                :disabled='!selectedForm.linked_form'
                @click="formSettingsDialog=true" >
                Settings
                <v-icon class='ml-2' small>settings</v-icon>
              </v-btn>

              <v-btn
                :disabled='!selectedForm.linked_form'
                @click='validatedialog=true' flat small >
                Connect
                <v-icon class='ml-2' small>sync_alt</v-icon>
              </v-btn>

              <v-btn
                :disabled='!selectedForm.linked_form'
                @click='sharedialog=true' target='_blank' flat small >
                Share
                <v-icon class='ml-2' small>share</v-icon>
              </v-btn>
              <v-btn :href='activeFormJotFormUrl' target='_blank' flat small >
                Open in JotForm
                <v-icon class='ml-2' small>open_in_new</v-icon>
              </v-btn>
            </v-toolbar>

            <v-alert :value='!selectedForm.linked_form' type='warning' >
              Note: This form has not been linked to AppointmentGuru.
              Would you like to link it now?
              <v-btn @click='linkdialog=true' >Link form</v-btn>
            </v-alert>

            <v-divider/>
            <v-card-title class="caption py-1 info--text"
              v-if="selectedForm && selectedForm.linked_form"
              @click="formSettingsDialog=true" >

              <v-chip small v-if="selectedForm.linked_form.include_on_appointment_page" >
                <v-icon left >check</v-icon> linked in notifications
                <help-popover small class='ml-4' >
                  <ul>
                  <li>If you are using the default notifications, this will add a link to a page with all your forms linked.</li>
                  <li>It will add the necessary information to link form submissions to your clients in AppointmentGuru.</li>
                  <li>If you have customized your notifications, this link might not be added</li>
                  <li>Links to your forms will show on the client's appointment detail page</li>
                  <li>Links will not be included if the client has already completed the form</li>
                  </ul>
                </help-popover>
              </v-chip>
              <v-chip small v-else >
                <v-icon left color="warning" >fiber_manual_record</v-icon> not linked in notifications
                <help-popover small class='ml-4' >
                  <ul>
                  <li>If you are using the default notifications, this will add a link to a page with all your forms linked.</li>
                  <li>It will add the necessary information to link form submissions to your clients in AppointmentGuru.</li>
                  <li>If you have customized your notifications, this link might not be added</li>
                  <li>Links to your forms will show on the client's appointment detail page</li>
                  <li>Links will not be included if the client has already completed the form</li>
                  </ul>
                </help-popover>
              </v-chip>
              <v-spacer/>

              Available in these spaces:
              <space-faces
                :space-ids="selectedForm.linked_form.spaces" />

              <v-btn small icon class="mr-2 ml-4" >
                <v-icon small >edit</v-icon></v-btn>

              <!-- <pre v-text="selectedForm" /> -->
            </v-card-title>

            <v-list dense>
              <v-subheader class='overline' >
                Recent submissions
                <v-spacer></v-spacer>
                <v-btn small icon
                  @click='getSubmissions(selectedForm.id)'
                  :loading='requests.submissions.loading' >
                  <v-icon small >replay</v-icon>
                </v-btn>
              </v-subheader>
              <v-divider ></v-divider>
              <tombstone v-if='requests.submissions.loading' ></tombstone>
              <template v-else >
                <p v-if="submissions && submissions.length === 0" class="caption pa-3" >No submissions found</p>
                <template v-for='submission in submissions' >
                  <!-- <pre v-if="submission.linked_submission" >{{submission.linked_submission.notifications}}</pre> -->
                  <submission-list-item
                    :item='submission'
                    :key='submission.id'
                    @assign_client='assigndialog=true;selectedSubmission=submission' >
                  </submission-list-item >
                  <v-divider :key="`div-${submission.id}`" ></v-divider>
                </template>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>

  <v-card class="mt-2"
    v-if="integrations && integrations.other_forms && integrations.other_forms.length > 0" >
    <v-card-title class='overline py-1 grey lighten-4' >
      <v-icon small class="mr-1" color="info" >info</v-icon>
      Some other forms have been linked by a colleague of yours
    </v-card-title>
    <v-divider/>
    <v-list>
      <template v-for="form in integrations.other_forms" >
        <form-list-item :key="form.id" :item="form" readonly />
      </template>
    </v-list>

  </v-card>

  <install-jot-form
    :integration="integration"
    @ok="getConfig"
    @delete="getConfig" />

  <!-- <v-dialog :value="true" fullscreen >
    <iframe src="https://settings.appointmentguru.co/#/wizards/invite/" width="100%" height="100%" />
    <v-btn class="mt-5" fab top right absolute ><v-icon>close</v-icon></v-btn>
  </v-dialog> -->

  <v-dialog v-model="formSettingsDialog" >
    <form-settings
      v-if="selectedForm && selectedForm.linked_form"
      :form-id='selectedForm.linked_form.id'
      @close="formSettingsDialog=false"
      @success="getForms" />
  </v-dialog>

  <v-dialog v-model='assigndialog' >
    <assign-form
      v-if='selectedSubmission  && selectedForm && selectedForm.linked_form'
      v-model='selectedSubmission'
      :form-id='selectedForm.linked_form.id'
      @close='assigndialog = false' />
  </v-dialog>

  <v-dialog v-model='linkdialog' :fullscreen="$vuetify.breakpoint.xs" >
    <link-jot-form
      v-if='selectedForm'
      :form='selectedForm'
      @close='linkdialog = false'
      @success='formLinked' />
  </v-dialog>

  <v-dialog v-model='validatedialog' :fullscreen="$vuetify.breakpoint.xs" fullscreen >
    <validate-form
      v-if="validatedialog && selectedForm && selectedForm.id"
      :form-id='selectedForm.id'
      :webhook-key="webhookKey"
      @close="closeValidate" />
  </v-dialog>

  <v-dialog v-model='sharedialog' width='520' >
    <share-form
      v-if="sharedialog && selectedForm && selectedForm.id"
      :form-id='selectedForm.id'
      @close="sharedialog=false" />
  </v-dialog>


</div>
</template>
<script>
import SubmissionListItem from '@/components/listitems/SubmissionListItem'
import SpaceFaces from '@/components/lists/SpaceFaces.vue'
import Tombstone from '@/components/app/Tombstone.vue'
import HelpPopover from '@/components/ui/HelpPopover.vue'
import InstallJotForm from './InstallJotForm.vue'
import LinkJotForm from './LinkJotForm.vue'
import FormListItem from './FormListItem.vue'
import AssignForm from './AssignForm.vue'
import ValidateForm from './ValidateForm.vue'
import ShareForm from './ShareForm.vue'
import FormSettings from './FormSettings.vue'

const JOTFORM_BASE = 'https://jotform.com'

export default {
  name: 'JotFormIntegrationPage',
  components: {
    SubmissionListItem,
    Tombstone,
    SpaceFaces,
    HelpPopover,
    AssignForm,
    ValidateForm,
    LinkJotForm,
    FormListItem,
    InstallJotForm,
    ShareForm,
    FormSettings
  },
  data () {
    return {
      apikey: '',
      eu: false,
      settings: {},
      selectedForm: {},
      validatedialog: false,
      sharedialog: false,
      linkdialog: false,
      assigndialog: false,
      showDeleted: false,
      showArchived: false,
      showUnlinked: true,
      formSettingsDialog: false,
      selectedSubmission: null,
      requests: {
        configure: {
          resource: 'ag.integrations',
          extra: 'jotform/configure',
          status: 0
        },
        integrations: {
          resource: 'ag.integrations',
          extra: 'jotform/integrations',
          status: 0
        },
        // delete: {
        //   resource: 'ag.integrations',
        //   extra: 'jotform/delete'
        // },
        // link: {
        //   resource: 'ag.integrations',
        //   extra: 'jotform/link',
        //   status: 0,
        //   loading: false
        // },
        forms: {
          resource: 'ag.integrations',
          extra: 'jotform/forms',
          status: 0
        },
        submissions: {
          resource: 'ag.integrations',
          extra: 'jotform/submissions',
          status: 0
        }
      }
    }
  },
  mounted () {
    this.getConfig()
    this.getIntegrations()
  },
  watch: {
    getConfigStatus () {
      if (this.getConfigStatus === 200) {
        this.getForms()
        this.apikey = this.getObjectPath(this.requests, 'configure.result.token')
        this.settings = this.getObjectPath(this.requests, 'configure.result.settings')
        if (this.settings) {
          this.eu = this.settings.eu
        }
      }
    },
    formsRequestStatus () {
      if (this.formsRequestStatus === 200 && this.selectedForm && this.selectedForm.id) {
        this.setSelectedFormById(this.selectedForm.id)
      }
    }
  },
  computed: {
    getConfigStatus () {
      return this.requests.configure.status
    },
    formsRequestStatus () {
      return this.requests.forms.status
    },
    integration () {
      return this.requests.configure.result
    },
    webhookKey () {
      if (this.integration) {
        return this.integration.service_user_id
      }
      return null
    },
    integrations () {
      let blank = {owned: [], other_forms: []}
      return this.getObjectPath(this.requests, 'integrations.result', blank)
    },
    getFormsStatus () {
      return this.requests.forms.status
    },
    linkFormStatus () {
      return this.requests.link.status
    },
    forms () {
      return this.getObjectPath(this.requests, 'forms.result', [])
    },
    filteredForms () {
      let forms = this.forms
      if (this.showDeleted === false) {
        forms = forms.filter((form) => { return form.status !== 'DELETED' })
      }
      if (this.showArchived === false) {
        forms = forms.filter((form) => { return form.status !== 'DISABLED' })
      }
      if (this.showUnlinked === false) {
        forms = forms.filter((form) => { return 'linked_form' in form })
      }
      return forms
    },
    submissions () {
      return this.getObjectPath(this.requests, 'submissions.result.content', [])
    },
    activeFormJotFormUrl () {
      return JOTFORM_BASE + '/build/' + this.selectedForm.id
    }
  },
  methods: {
    setSelectedForm (form) {
      this.selectedForm = form
      this.getSubmissions(form.id)
      // selectedForm=form;linkdialog=true
    },
    showLinkFormDialog (form) {
      this.setSelectedForm(form)
      this.linkdialog = true
    },
    setSelectedFormById (formId) {
      let form = this.forms.find((f) => {
        if (f.id === formId) { return true }
      })
      if (form) { this.setSelectedForm(form) }
    },
    closeValidate (formId) {
      this.setSelectedFormById(formId)
      this.validatedialog = false
    },
    formLinked () {
      this.getForms()
      this.linkdialog = false
      this.getSubmissions(this.selectedForm.id)
      this.validatedialog = true
    },
    // link (jotformId) {
    //   this.requests.link.data = { jotform_id: jotformId }
    //   this.$request('save', this.requests.link)
    // },
    getIntegrations () {
      this.$request('get', this.requests.integrations)
    },
    getConfig () {
      this.$request('get', this.requests.configure)
    },
    getForms () {
      this.$request('get', this.requests.forms)
    },
    getSubmissions (formId) {
      this.requests.submissions.params = { form_id: formId }
      this.$request('get', this.requests.submissions)
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?2d2d1587